<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-18 10:42:19
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-04 16:09:36
-->
<template>
  <div class="index-hxcp wh100">
    <div class="ui-index-title">{{ $t('frontPage.hexinchanping.title') }}</div>
    <div>
      <div class="index-hxcp-top">
        <div class="index-hxcp-top-up flex align_items_center">
          <div class="flex_1 flex align_items_center">
            <div class="index-hxcp-top-imgbox">
              <div class="top-img" :class="{ imgsmall: activeName != 'skull' }" @click="typeClick('skull')">
                <img class="wid100" :src="$t('frontPage.hexinchanping.innovative.skull.img')" alt="" srcset="">
              </div>
              <div class="top-img" :class="{ imgsmall: activeName != 'heart' }" @click="typeClick('heart')">
                <img class="wid100" :src="$t('frontPage.hexinchanping.innovative.heart.img')" alt="" srcset="">
              </div>
            </div>
            <div class="index-hxcp-top-title flex_1 flex align_items_center" >
              <p class="p-r-5" v-html="$t(`frontPage.hexinchanping.innovative.${activeName}.title`)"></p>
              <div class="ilblk" @click="typeClick()">
                <img :src="require('@/assets/images/m/index/hxcp/exchange.png')" alt="" srcset="">
              </div>
            </div>
          </div>
          <div>
            <span class="index-hxcp-top-more" v-html="$t('frontPage.hexinchanping.innovative.more')" @click="jumpPath(`${language == 'en' ? '/en' : ''}/innovative/${$t(`frontPage.hexinchanping.innovative.${activeName}.more`)}`)"></span>
          </div>
        </div>
        <el-row>
          <el-col :span="12" class="index-hxcp-top-list" v-for="item, index in $t(`frontPage.hexinchanping.innovative.${activeName}.list`)" :key="index"><span v-html="item.title" @click="jumpPath(item.path)"></span></el-col>
        </el-row>
      </div>
      <div class="index-hxcp-middle">
        <div class="flex flex_col justify_content_center align_items_center posrel">
          <img class="wid100 m-t-2" :src="$t('frontPage.hexinchanping.innovative.img_circle')" alt="" srcset="">
          <img class="index-hxcp-middle-circle_arraw" :src="require('@/assets/images/index/hxcp/circle_arraw.png')" alt="" srcset="">
          <div class="flex justify_content_center align_items_center">
            <div class="mini-circle flex flex_col justify_content_center align_items_center" v-for="item, index in $t('frontPage.hexinchanping.innovative.circle_list')" :key="index">
              <img :src="item.img" alt="" srcset="">
              <div class="p-t-8" v-html="item.title"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="indx-hxcp-arrow">
        <img class="wid100" :src="require('@/assets/images/m/index/hxcp/arrow.png')" alt="" srcset="">
      </div>
      <div>
        <img class="wid100" :src="$t('frontPage.hexinchanping.innovative.m_b_img')" alt="" srcset="">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      nameList: ['skull', 'heart'],
      activeName: 'skull'
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth'])
  },
  created () {
    this.closeInterval()
    this.openInterval()
  },
  methods: {
    typeClick (name) {
      this.closeInterval()
      this.openInterval()
      this.activeName = name === undefined ? this.nameList[this.activeName === 'skull' ? 1 : 0] : name
    },
    jumpPath (_path) {
      console.log(_path)
      this.$router.push({ path: _path })
    },
    openInterval () {
      this.timer = setInterval(() => {
        const index = this.nameList.findIndex(item => item === this.activeName)
        this.activeName = this.nameList[index === 0 ? 1 : 0]
      }, 4 * 1000)
    },
    closeInterval () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  },
  destroyed () {
    this.closeInterval()
  }
}
</script>

<style lang="less" scoped>
@keyframes slideUp {
  0% {
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
    -moz-transform: translate3d(0, 100%, 0);
    -ms-transform: translate3d(0, 100%, 0);
    -o-transform: translate3d(0, 100%, 0);
    opacity: 0.2;
  }
  20% {
    -webkit-transform: translate3d(0, 50%, 0);
    transform: translate3d(0, 50%, 0);
    -moz-transform: translate3d(0, 50%, 0);
    -ms-transform: translate3d(0, 50%, 0);
    -o-transform: translate3d(0, 50%, 0);
    opacity: 0.2;
  }
  50%, 100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    -moz-transform: translateZ(0);
    -ms-transform: translateZ(0);
    -o-transform: translateZ(0);
    opacity: 1;
  }
}
.m .index-hxcp {
  padding: 30px 30px 50px 30px;
  .index-hxcp-top {
    background: #FFFFFF;
    box-shadow: 0px 6px 10px 3px rgba(95,184,233,0.18);
    border-radius: 6px;
    margin-top: 20px;
    padding: 16px 30px 16px 0;
    .index-hxcp-top-up {
      font-size: 24px;
      height: 50px;
      .index-hxcp-top-imgbox {
        // height: 100px;
        width: 136px;
        position: relative;
        bottom: 55px;
        left: -2px;
        .top-img {
          width: 90px;
          position: absolute;
          z-index: 3;
          webkit-transform: translate3d(0, 0, 0) scale(1);
          -moz-transform: translate3d(0, 0, 0) scale(1);
          -ms-transform: translate3d(0, 0, 0) scale(1);
          -o-transform: translate3d(0, 0, 0) scale(1);
          transform: translate3d(0, 0, 0) scale(1);
          transition: transform 0.8s ease;
          &.imgsmall {
            webkit-transform: translate3d(55px, 0, 0)  scale(0.75);
            -moz-transform: translate3d(55px, 0, 0) scale(0.75);
            -ms-transform: translate3d(55px, 0, 0) scale(0.75);
            -o-transform: translate3d(55px, 0, 0) scale(0.75);
            transform: translate3d(55px, 0, 0) scale(0.75);
            z-index: 2;
          }
        }
      }
      .index-hxcp-top-title {
        padding-left: 22px;
        img {
          width: 30px;
        }
      }
    }
    .index-hxcp-top-more {
      color: #00A1E9;
      display: inline-block;
    }
    .index-hxcp-top-list {
      text-align: center;
      font-size: 24px;
      line-height: 36px;
      padding: 18px 20px;
      color: #333333;
      font-weight: 600;
      // &:hover {
      //   color: #0069B3;
      // }
    }
  }
  .index-hxcp-middle {
    width: 80%;
    margin: 0 auto;
    padding-top: 68px;
    padding-bottom: 20px;
    .index-hxcp-middle-circle_arraw {
      position: absolute;
      width: 92%;
      margin-right: 10px;
      margin-top: 2px;
      animation: refresh-rotate 10s linear infinite;
    }
    .mini-circle {
      position: absolute;
      z-index: 3;
      width: 23%;
      height: 23%;
      border-radius: 50%;
      background: #ffffff;
      box-shadow: 2px 2px 12px 4px rgba(81, 170, 255, 0.3);
      font-size: 28px;
      font-weight: bold;
      img {
        max-height: 46px;
      }
      &:nth-of-type(1) {
        top: 10px;
      }
      &:nth-of-type(2) {
        left: 5%;
        bottom: 19%;
      }
      &:nth-of-type(3) {
        right: 5.3%;
        bottom: 19%;
      }
    }
  }
  .indx-hxcp-arrow {
    padding: 0 10%;
    position: relative;
    animation: slideUp 3s linear infinite;
  }
}
.m.en .index-hxcp {
  .index-hxcp-top .index-hxcp-top-up {
    padding-bottom: 20px;
    height: auto;
    .index-hxcp-top-title {
      padding-right: 20px;
      line-height: 32px;
    }
  }
  .index-hxcp-middle {
    width: 90%;
    .mini-circle {
      font-size: 20px;
      img {
        max-height: 54px;
      }
    }
  }
}
</style>
